import { callApi } from "./api.service";

// Define the search function (No token required)
export const Search = async (query: string) => {
  const endpoint = `/api/public/search/suggestions?query=${encodeURIComponent(
    query
  )}`;
  return await callApi(endpoint, "GET", false);
};

// Define the search function with Filter (No token required)
export const SearchResultWithFilter = async (data: any) => {
  const endpoint = `/api/public/search/result/filter`;
  return await callApi(endpoint, "POST", false, undefined, data);
};

// Define the search function with Filter (token required)
export const SearchResultWithToken = async (
  data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/search/result/filter`;
  return await callApi(endpoint, "POST", true, getToken, data);
};
